import sidebar from './sidebar'
import branches from './branches'
import dataTable from './dataTable'
import equipment from './equipment'
import customers from './customers'
import users from './users'
import user from './user'
import installations from './installations'
import billing from './billing'
import invoices from './invoices'
import auth from './auth'
import payments from './payments'
import dashboard from './dashboard'
import common from './common'
import noc from './noc'
import qboAccounts from './qboAccounts'
import payees from './payees'

export default {
    sidebar,
    branches,
    dataTable,
    equipment,
    customers,
    users,
    user,
    installations,
    billing,
    invoices,
    auth,
    payments,
    dashboard,
    common,
    noc,
    qboAccounts,
    payees,
}
